export default "__VITE_ASSET__BqCKsWEy__"